import { useEffect } from 'react';
import Seo from '../../components/feature/Seo';

/**
 * Preview page handler for Strapi preview feature
 * This route receives preview requests from Strapi admin panel
 * and redirects to the appropriate page with preview mode enabled
 */
export default function PreviewPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const secret = params.get('secret');
    const documentId = params.get('documentId');
    const type = params.get('type');
    const slug = params.get('slug');
    const locale = params.get('locale');

    // Validate secret
    const expectedSecret = import.meta.env.VITE_PREVIEW_SECRET || 'my-super-secret-preview-token-2024';

    if (secret !== expectedSecret) {
      console.error('Invalid preview secret');
      window.location.href = '/';
      return;
    }

    // Store preview mode in sessionStorage
    sessionStorage.setItem('preview-mode', 'true');
    sessionStorage.setItem('preview-documentId', documentId || '');
    if (locale) sessionStorage.setItem('preview-locale', locale);

    // Redirect based on content type
    let redirectUrl = '/';

    switch (type) {
      case 'blog-post':
        redirectUrl = slug ? `/blog/${slug}` : '/blog';
        break;
      case 'about':
        redirectUrl = '/ueber-mich';
        break;
      case 'blog-section':
        redirectUrl = '/blog';
        break;
      case 'services-section':
        redirectUrl = '/';
        break;
      case 'contact-section':
        redirectUrl = '/kontakt';
        break;
      default:
        // For hero-banner and other single types, redirect to home
        redirectUrl = '/';
    }

    // Redirect to the preview page
    window.location.href = redirectUrl;
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <Seo
        title="Preview"
        description="Strapi preview redirect."
        path="/api/preview"
        noindex
      />
      <div style={{ textAlign: 'center' }}>
        <h2>Loading preview...</h2>
        <p>Redirecting to preview mode</p>
      </div>
    </div>
  );
}
